export class Serie {
  constructor({
    id = null,
    nome = null,
    descricao = null,
    modalidade = null,
    quantidadeBimestres = null,
  }) {
    this.id = id;
    this.nome = nome;
    this.descricao = descricao;
    this.modalidade = modalidade;
    this.quantidadeBimestres = quantidadeBimestres;
  }
  static Build() {
    return new Serie({
      id: null,
      nome: null,
      codigo: null,
      descricao: null,
    });
  }
  format() {
    return {
      id: this.id,
      nome: this.nome,
      descricao: this.descricao,
      modalidade: typeof this.modalidade === "object" ? this.modalidade?.id : this.modalidade,
      quantidadeBimestres: this.quantidadeBimestres,
    };
  }
}
